import { EJsonQueryPriceType } from '@cian/api-models/common/json_query';
import { RadioButtonGroup } from '@cian/ui-kit';

import React, { ChangeEvent, memo, useCallback } from 'react';

import { usePriceTypeSelector } from '../../../../../hooks/selectors/usePriceTypeSelector';
/**
 * @start
 * @todo Удалить блок с RS
 * @description Данный функционал появился в задаче CD-93942, будет удалён в задаче CD-97910
 */
import { getCoworkingWorkplacePriceEnabled } from '../../../../../utils/getCoworkingWorkplacePriceEnabled';
/**
 * @end
 */

import { NumberInput } from '../../../../NumberInput';

import { coworkingSwitchButtonsMapper } from '../../mappers/coworkingSwitchButtonsMapper';

import * as styles from './CoworkingPriceDropdown.css';
import { ICoworkingPriceDropdownProps } from './types';

export const CoworkingPriceDropdown = memo<ICoworkingPriceDropdownProps>(function CoworkingPriceDropdown(props) {
  const { isErroneous, max, min, onMaxBlur, onMaxValueChange, onMinBlur, onMinValueChange, onPriceTypeChange } = props;

  const priceType = usePriceTypeSelector() || 'all';

  const handlePriceTypeChange = useCallback<(event: ChangeEvent<HTMLInputElement>, value: EJsonQueryPriceType) => void>(
    (_event, coworkingPriceType) => {
      if (Object.values(EJsonQueryPriceType).includes(coworkingPriceType)) {
        onPriceTypeChange(coworkingPriceType);
      } else {
        onPriceTypeChange(undefined);
      }
    },
    [onPriceTypeChange],
  );

  return (
    <div className={styles['container']}>
      {/**
       * @todo Удалить ветвление с RS
       * @description Данный функционал появился в задаче CD-93942, будет удалён в задаче CD-97910
       */
      getCoworkingWorkplacePriceEnabled() && (
        <div className={styles['prise-type-switch']}>
          <RadioButtonGroup
            name="prise-type-switch"
            onChange={handlePriceTypeChange}
            options={coworkingSwitchButtonsMapper}
            value={priceType}
          />
        </div>
      )}
      <div className={styles['inputs-container']}>
        <NumberInput
          className={styles['input']}
          error={isErroneous}
          onBlur={onMinBlur}
          onValueChange={onMinValueChange}
          placeholder="от"
          suffix={`\u20bd`}
          value={min}
        />
        <NumberInput
          className={styles['input']}
          error={isErroneous}
          onBlur={onMaxBlur}
          onValueChange={onMaxValueChange}
          placeholder="до"
          suffix={`\u20bd`}
          value={max}
        />
      </div>
    </div>
  );
});
